import Configs from './Config';

const production: Configs = {
  dashboardUrl: 'https://dashboard.casa.ajira.tech',
  ruleServerUrl: 'https://api.casa.ajira.tech',
  casaWebAppUrl: 'https://web.casa.ajira.tech',
  casaEcomUrl: 'https://ecom.casa.ajira.tech',
  casaBeatUrl: 'https://beat-api.casa.ajira.tech',
  turnedOffFeatures: [],
  keycloakConfig: {
    url: `https://auth.casa.ajira.tech/auth`,
    realm: `casa`,
    clientId: `casa_dashboard`,
  },
};

export default production;
